import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=b83fbd66&scoped=true&"
import script from "./NotificationDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=b83fbd66&lang=scss&scoped=true&"
import style1 from "./NotificationDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83fbd66",
  null
  
)

export default component.exports